import { useApi } from './useApi';
import { url } from '../../utils/confserveur';

/**
 * Profil XP de l'élève connecté (GET /profils-xp/me/).
 * Le profil est auto-créé côté back au premier appel.
 *
 * @param {*} refresh - change de valeur pour forcer un re-fetch (ex. après soumission d'un quiz)
 * @param {boolean} enabled - false (ex. utilisateur non élève) → requête désactivée (évite le 403)
 * @returns {{data, isLoading, isError}}
 */
export const useProfilXp = (refresh, enabled = true) =>
  useApi(`${url}profils-xp/me/`, null, refresh, enabled ? null : 'not-enabled');
